import React from 'react'
import './styles.scss'

type IconButtonProps = {
  icon: React.ReactNode
  width?: number
  [x: string]: any
}

type SvgIconProps = {
  width?: number
  height?: number
  style?: React.CSSProperties
  className?: string
}

const IconButton = React.forwardRef(({ icon, width = 24, ...rest }: IconButtonProps, ref: any) => {
  const isImageUrl = typeof icon === 'string' && (icon.startsWith('/') || icon.startsWith('data:') || icon.endsWith('.svg'))

  const renderIcon = () => {
    if (isImageUrl) {
      return <img src={icon as string} alt="" width={width} height={width} />
    }
    if (React.isValidElement<SvgIconProps>(icon)) {
      const { width: iconWidth, height: iconHeight } = icon.props
      const size = iconWidth ?? width
      const height = iconHeight ?? size
      return React.cloneElement(icon, {
        width: size,
        height,
        style: { width: size, height },
      })
    }
    return icon
  }

  return (
    <button className='btn btn-link icon-button m-0 p-0' ref={ref} {...rest}>
      {renderIcon()}
    </button>
  )
})

export default IconButton